import React from "react";
const AttentionIcon = ({
  className
}) => {
  return /*#__PURE__*/React.createElement("svg", {
    className: className ? className : "",
    width: "26",
    height: "24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.871 2.21c1.155-2 4.042-2 5.196 0l9.527 16.5c1.154 2-.29 4.5-2.599 4.5H3.944c-2.31 0-3.753-2.5-2.598-4.5l9.526-16.5Z",
    fill: "#FBDCE1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m23.861 19.71-9.526-16.5a1 1 0 0 0-1.732 0l-9.526 16.5a1 1 0 0 0 .866 1.5h19.053a1 1 0 0 0 .866-1.5Zm-7.794-17.5c-1.154-2-4.041-2-5.196 0l-9.526 16.5c-1.155 2 .289 4.5 2.598 4.5h19.053c2.309 0 3.752-2.5 2.598-4.5l-9.527-16.5Z",
    fill: "#DD304F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.47 5.84v8.24M13.47 17.666v1.479",
    stroke: "#003A56",
    strokeWidth: "2",
    strokeLinecap: "round"
  }));
};
export default AttentionIcon;